import { Page, Layout, BlockStack, Text, Card, Banner } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ChatWidget from '../components/ChatWidget';
import { useShop } from '../context/ShopContext';
import { UpgradeBanner } from '../components/UpgradeBanner';

export default function ChatPage() {
  const navigate = useNavigate();
  const { shop, shopInfo, isLoading } = useShop();
  const { t } = useTranslation();

  // Plan gating: AI Chat requires Growth+
  const hasAiChat = shopInfo?.planFeatures?.hasAiChat !== false;
  if (!hasAiChat) {
    return (
      <Page
        title={t('chat.pageTitle')}
        backAction={{ onAction: () => navigate('/app') }}
      >
        <Layout>
          <Layout.Section>
            <UpgradeBanner feature="aiChat" requiredPlan="Growth" />
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  if (!shop && !isLoading) {
    return (
      <Page title={t('chat.pageTitle')}>
        <Banner tone="warning">
          <p>{t('chat.noShopDetected')}</p>
        </Banner>
      </Page>
    );
  }

  return (
    <Page
      title={t('chat.pageTitle')}
      subtitle={t('chat.pageSubtitle')}
      backAction={{ onAction: () => navigate('/app') }}
    >
      <Layout>
        <Layout.Section>
          <BlockStack gap="500">
            <Banner tone="info">
              <p>
                <strong>🚀 {t('common.enabled')}!</strong> {t('chat.newFeatureBanner')}
              </p>
            </Banner>

            <ChatWidget />
          </BlockStack>
        </Layout.Section>

        <Layout.Section variant="oneThird">
          <BlockStack gap="400">
            <Card>
              <BlockStack gap="300">
                <Text as="h2" variant="headingMd">💡 {t('chat.tips')}</Text>
                <BlockStack gap="200">
                  <Text as="p" variant="bodySm">
                    • {t('chat.tip1')}
                  </Text>
                  <Text as="p" variant="bodySm">
                    • {t('chat.tip2')}
                  </Text>
                  <Text as="p" variant="bodySm">
                    • {t('chat.tip3')}
                  </Text>
                  <Text as="p" variant="bodySm">
                    • {t('chat.tip4')}
                  </Text>
                </BlockStack>
              </BlockStack>
            </Card>

            <Card>
              <BlockStack gap="300">
                <Text as="h2" variant="headingMd">📚 {t('chat.commonTopics')}</Text>
                <BlockStack gap="200">
                  <Text as="p" variant="bodySm">
                    {t('chat.topicConfig')}
                  </Text>
                  <Text as="p" variant="bodySm">
                    {t('chat.topicDiagnostic')}
                  </Text>
                  <Text as="p" variant="bodySm">
                    {t('chat.topicMl')}
                  </Text>
                  <Text as="p" variant="bodySm">
                    {t('chat.topicSales')}
                  </Text>
                </BlockStack>
              </BlockStack>
            </Card>

            <Card>
              <BlockStack gap="300">
                <Text as="h2" variant="headingMd">🔒 {t('chat.privacy')}</Text>
                <Text as="p" variant="bodySm" tone="subdued">
                  {t('chat.privacyDesc')}
                </Text>
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
